import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/ENAR43/ENAR43_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam SKills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Answers',
        ImagePath: '/assets/images/landing/answers.png',
        DestinationPage: 'Answers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ExamSkillsVideos,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch videos',
    ButtonURL: 'videos',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Exam Skills Videos',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Our experts talk you through how to answer each different-question-type in the exams.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Learn how to write a top answer',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Exam Skills Videos',
        Intro:
          'GCSE English has lots of different question types, and our experts will show you how to write a top answer for each one in these step-by-step videos!',
        LeftSections: [
          {
            Header: 'Paper 1',
            Subcategories: [
              {
                Name: 'Question 1',
                ShortName: 'p1-question-1',
                Link: 'https://www.youtube.com/embed/U3RoH3keuJA?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 2',
                ShortName: 'p1-question-2',
                Link: 'https://www.youtube.com/embed/eUvXlA_abGw?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 3',
                ShortName: 'p1-question-3',
                Link: 'https://www.youtube.com/embed/HFBqB5Kzalo?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 4',
                ShortName: 'p1-question-4',
                Link: 'https://www.youtube.com/embed/PkJD5JpG1To?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 5',
                ShortName: 'p1-question-5',
                Link: 'https://www.youtube.com/embed/TrMY95ehQsA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Paper 2',
            Subcategories: [
              {
                Name: 'Question 1',
                ShortName: 'p2-question-1',
                Link: 'https://www.youtube.com/embed/XG3KSJ3cQdY?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 2',
                ShortName: 'p2-question-2',
                Link: 'https://www.youtube.com/embed/DPaX_lHFb70?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 3',
                ShortName: 'p2-question-3',
                Link: 'https://www.youtube.com/embed/zdEPBFZOakQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 4',
                ShortName: 'p2-question-4',
                Link: 'https://www.youtube.com/embed/3vn4rZUKnxQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Question 5',
                ShortName: 'p2-question-5',
                Link: 'https://www.youtube.com/embed/tnXhFgsy-aU?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam SKills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Answers',
        ImagePath: '/assets/images/landing/answers.png',
        DestinationPage: 'Answers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Answers,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View answers',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Answers',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See what makes a great answer in the exams! You can also find all your Revision Summary Test answers here.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Graded examples for each paper',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: 'Answers',
      ContentMain:
        '<div class="free-content">' +
        "<p>Take a look at our example answers for some of the AQA English exam questions — they\'re fully graded to show you the sort of thing examiners are looking for.</p>" +
        '<p>You can also check out the answers to your Revision Summary Tests.</p>' +
        '<p><strong>Fully Graded Answers</strong></p>' +
        '<p><strong><span style="color:#1494D4;"><a href="[[cloudfront_url]]/_revisionhub_opc/ENAR43/PDFs/cgp-gcse-english-full-graded-ans-p1q5.pdf" target="_blank">Paper 1 Q5 Graded Answers</a><br>' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/ENAR43/PDFs/cgp-gcse-english-full-graded-ans-p2q5.pdf" target="_blank">Paper 2 Q5 Graded Answers</a></span></strong></p>' +
        '<p><strong>Revision Summary Answers</strong></p>' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/ENAR43/PDFs/cgp-gcse-english-revision-summary-answers.pdf" target="_blank"><span style="color:#1494D4;"><strong>Revision Summary Answers</strong></span></a></p><div>',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam SKills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Answers',
        ImagePath: '/assets/images/landing/answers.png',
        DestinationPage: 'Answers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text:
        '<h2>AQA English Language RevisionHub FAQs <!--//h2--></h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?   <!--/h5--></h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE English Language books. Use the tests, videos and more to revise what you’ve learned from your book and practise for the exams.</p>\n' +
        '\n' +
        '<h5>How do I access CGP RevisionHub?  </h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.  </p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?  </h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Give them a scan and you'll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you've learned!  </p>\n" +
        '\n' +
        '<h5>My CGP RevisionHub isn’t working — what do I do?  </h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...  </p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?  </h5>\n' +
        '\n' +
        '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.  </p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?  </h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.  </p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in CGP RevisionHub and start again?  </h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But, you can edit your Revision Summary Test answers as your skills and understanding develop. Keep going, we believe in you!  </p>\n" +
        '\n' +
        '<h5>Can I share my test results with other people?  </h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?  </p>\n" +
        '\n' +
        '<h5>What happens when I’ve answered all the questions?  </h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams.</p>\n" +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?  </h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise. </p>",
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
      {
        Text: 'Exam SKills Videos',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Online Edition',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: '[[external_domain]]/online-products',
        IsExternalLink: true,
      },
      {
        Text: 'Answers',
        ImagePath: '/assets/images/landing/answers.png',
        DestinationPage: 'Answers',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from! Take a look at some of our other revision books.",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];

